import {Entity, JoinColumn, OneToMany, OneToOne} from "typeorm";
import type {Relation} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {TerraceLog} from "@/modules/stadium/entity/TerraceLog";
import {Match} from "@/modules/match/entity";

@Entity()
export class StadiumLog extends BaseEntity {
  @OneToOne(() => Match, r => r.stadiumLog)
  @JoinColumn()
  match: Relation<Match>;

  @OneToMany(() => TerraceLog, r => r.stadiumLog, {eager: true})
  terraceLogs: Relation<TerraceLog[]>;

  get seats() {
    return collect(this.terraceLogs)
      .sum((terraceLog: TerraceLog) => terraceLog.seats);
  }

  get capacity() {
    return collect(this.terraceLogs)
      .sum((terraceLog: TerraceLog) => terraceLog.capacity);
  }

  get isSoldOut() {
    return this.seats === this.capacity;
  }
}
